var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { className: styles["st0"] || "st0", d: "M4 2c-.5 0-1 .2-1.4.6C2.2 3 2 3.5 2 4v12c0 .5.2 1 .6 1.4.4.4.9.6 1.4.6h4v3c0 .3.1.5.3.7.2.2.4.3.7.3h.5c.2 0 .5-.1.7-.3l3.7-3.7H20c.5 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4V4c0-1.1-.9-2-2-2H4zm0 2h16v12h-6.9L10 19.1V16H4V4zm8.2 1.5c-.9 0-1.6.2-2.1.5-.6.4-.9 1-.8 1.7h2c0-.3.1-.5.3-.6.2-.1.4-.2.7-.2.3 0 .6.1.8.3.2.2.3.4.3.7 0 .3-.1.5-.2.7-.2.2-.4.4-.6.5-.5.3-.9.6-1.1.8-.4.3-.5.6-.5 1.1h2c0-.3.1-.5.1-.7.1-.2.3-.3.5-.5.5-.2.8-.5 1.1-.9.3-.4.4-.8.4-1.2 0-.7-.3-1.3-.8-1.7-.4-.3-1.2-.5-2.1-.5zM11 12v2h2v-2h-2z" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/support.svg